
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import GroupCusAdd from "../components/groupCustomerAdd";
import Footer from "../components/footer";

function GroupCusAddPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <GroupCusAdd /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default GroupCusAddPage;